
const digest = 'de0661330b5c2134a3ff551ebd32d8b317b63a9db5a91305bb477a6f8f60ded7';
const classes = {"container":"_container_7xi6s_1","row":"_row_7xi6s_11","item":"_item_7xi6s_20","itemBig":"_itemBig_7xi6s_20","itemMedium":"_itemMedium_7xi6s_20","itemSmall":"_itemSmall_7xi6s_20","itemDisabled":"_itemDisabled_7xi6s_50","itemSelected":"_itemSelected_7xi6s_56"};
const css = `._container_7xi6s_1 {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  width: 348px;
  box-shadow: 3px 0 6px 0 rgba(0, 0, 0, 0.08);
  font-family: "Rubik", sans-serif;
}

._row_7xi6s_11 {
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  justify-content: center;
  align-items: center;
}

._item_7xi6s_20, ._itemBig_7xi6s_20, ._itemMedium_7xi6s_20, ._itemSmall_7xi6s_20 {
  cursor: pointer;
  text-align: center;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  box-shadow: 0 2px 0 0 #e6e7eb;
  background: #f2f4f7;
  transition: 0.2s;
  transition-property: color, background-color, box-shadow;
  color: #7a8599;
  user-select: none;
  font-size: 14px;
}

._itemSmall_7xi6s_20 {
  min-width: 100px;
}

._itemMedium_7xi6s_20 {
  min-width: 154px;
  min-height: 140px;
}

._itemBig_7xi6s_20 {
  min-width: 316px;
}

._itemDisabled_7xi6s_50 {
  box-shadow: 0 0 0 1px #e6e7eb;
  background: white;
  cursor: default;
}

._itemSelected_7xi6s_56 {
  background: white;
  border: 2px solid #7a8599;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  